<template>
  <div class="ps-news-detail">
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">読み込み中</span>
      </div>
    </div>
    <div v-else-if="record">
      <p class="text-muted small mb-3">公開日: {{ record.published_at || '未設定' }}</p>
      <!-- 管理者作成の信頼コンテンツのため v-html でリッチテキストを表示（プラン方針に準拠） -->
      <div class="ps-news-detail__body" v-html="record.body"></div>
    </div>
    <div v-else class="text-center py-5 text-muted">
      お知らせが見つかりませんでした
    </div>
  </div>
</template>

<script>
/**
 * お知らせ（ps_news）の詳細をモーダル内で閲覧するコンポーネント。
 * VirtualModel ps_news_public の indexListItemOnClick からモーダル表示される想定。
 */
export default {
  name: 'PsNewsDetailModal',
  props: {
    /** 表示対象の ps_news レコード ID */
    recordId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      /** API 取得中フラグ */
      loading: true,
      /** findById で取得したレコード（失敗時は null のまま） */
      record: null,
    }
  },
  async created() {
    try {
      // CORE のモデル API で単件取得
      this.record = await $core.$models.ps_news.findById(this.recordId)
    } catch (e) {
      console.error('Failed to load news detail:', e)
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.ps-news-detail__body {
  line-height: 1.8;
}
/* リッチテキスト内の画像がモーダル幅をはみ出さないよう制限 */
.ps-news-detail__body :deep(img) {
  max-width: 100%;
  height: auto;
}
</style>
